var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78947 14.0526V12.3684M9 14.0526V11.5263M13.2105 14.0526V9.84211M1 9C1 5.22905 1 3.34274 2.17137 2.17137C3.34274 1 5.22821 1 9 1C12.7709 1 14.6573 1 15.8286 2.17137C17 3.34274 17 5.22821 17 9C17 12.7709 17 14.6573 15.8286 15.8286C14.6573 17 12.7718 17 9 17C5.22905 17 3.34274 17 2.17137 15.8286C1 14.6573 1 12.7718 1 9Z",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 8.56678C5.75614 8.62741 9.87151 8.35372 12.2126 4.63836M10.6782 4.18951L12.258 3.9352C12.45 3.91078 12.733 4.0632 12.8029 4.24425L13.2197 5.62362",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.cc95119c89c9c40f16d392b5c07ac4bc.svg";
export { ForwardRef as ReactComponent };